module.exports = __webpack_public_path__ + "static/16-3ba5308b40700291c65c5e45710fedf6.png";